// Pequeno event bus para controle desacoplado do snackbar
// Evita a re-renderização dos filhos do Provider ao mostrar/ocultar o Snackbar

const listeners = new Set()

const snackbarBus = {
  subscribe(listener) {
    listeners.add(listener)
    return () => listeners.delete(listener)
  },
  show(params) {
    listeners.forEach((l) => l({ type: 'SHOW', payload: params }))
  },
  hide() {
    listeners.forEach((l) => l({ type: 'HIDE' }))
  },
}

export default snackbarBus
